import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { IncludeContent } from '../IncludeContent';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

export class HiddenContent extends React.Component {
  state = { isShown: false };

  toggle = () => {
    const { isShown } = this.state;
    this.setState({ isShown: !isShown });
  };

  render() {
    const { isShown } = this.state;
    const { label, content } = this.props;
    return (
      <div className={cx('wrapper')}>
        <div
          className={cx('toggle', { toggleActive: isShown })}
          onClick={this.toggle}
          role="button"
          tabIndex={0}
        >
          <span className={cx('dotted')}>{label}</span>
        </div>
        {isShown ?
          <div className={cx('content')}>
            <IncludeContent htmlContent={content} />
          </div>
        : null}
      </div>
    );
  }
}

HiddenContent.propTypes = {
  label: PropTypes.string,
  content: PropTypes.string,
};

HiddenContent.defaultProps = {
  label: 'Подробнее',
  content: '',
};
